var JumpInEventType;
(function (JumpInEventType) {
    JumpInEventType["JUMP_IN"] = "JUMP_IN";
    JumpInEventType["OPEN_DOWNLOAD_MODAL"] = "OPEN_DOWNLOAD_MODAL";
    JumpInEventType["DOWNLOAD"] = "DOWNLOAD";
})(JumpInEventType || (JumpInEventType = {}));
export { JumpInEventType };
//# sourceMappingURL=JumpIn.types.js.map